import ChargeHelper from 'features/Charge/chargeHelper';
import KTFormSearch from 'general/components/OtherKeenComponents/Forms/KTFormSearch';
import KTBSDropdown from 'general/components/OtherKeenComponents/KTBSDropdown';
import CustomDropdown2 from 'general/components/Others/CustomDropdown2';
import AppColors from 'general/constants/AppColors';
import AppConfigs from 'general/constants/AppConfigs';
import UIHelper from 'general/helpers/UIHelper';
import Utils from 'general/utils/Utils';
import PropTypes from 'prop-types';
import { useEffect, useMemo, useState } from 'react';

ChargeVehicleListFilterView.propTypes = {
  onCancel: PropTypes.func,
  onApply: PropTypes.func,
  initialSelectedBrand: PropTypes.object,
  initialSelectedModel: PropTypes.object,
  onSelectedBrandChange: PropTypes.func,
  onSelectedModelChange: PropTypes.func,
};

function ChargeVehicleListFilterView({
  onCancel,
  onApply,
  closeDropdown,
  initialSelectedBrand,
  initialSelectedModel,
  onSelectedBrandChange,
  onSelectedModelChange,
}) {
  // MARK: ---- PROPERTIES ----
  const [filterQ, setFilterQ] = useState('');
  const [filterStatus, setFilterStatus] = useState('');
  const [filterBrandId, setFilterBrandId] = useState('');
  const [filterModelId, setFilterModelId] = useState('');
  const [filterAutoCharge, setFilterAutoCharge] = useState('');
  const [selectedVehicleBrand, setSelectedVehicleBrand] = useState(null);
  const [selectedVehicleModel, setSelectedVehicleModel] = useState(null);
  useEffect(() => {
    setFilterQ(ChargeHelper.Filter.chargeVehicleList.q);
    setFilterStatus(ChargeHelper.Filter.chargeVehicleList.status);
    setFilterBrandId(ChargeHelper.Filter.chargeVehicleList.brandId);
    setFilterModelId(ChargeHelper.Filter.chargeVehicleList.modelId);
    setFilterAutoCharge(ChargeHelper.Filter.chargeVehicleList.autoCharge);
  }, [ChargeHelper.Filter.chargeVehicleList]);
  useEffect(() => {
    setSelectedVehicleBrand(initialSelectedBrand);
    setSelectedVehicleModel(initialSelectedModel);
  }, [initialSelectedBrand, initialSelectedModel]);
  const [defaultDropdownVehicleModel, setDefaultDropdownVehicleModel] = useState(null);
  useEffect(() => {
    setDefaultDropdownVehicleModel({
      name: 'Dòng xe',
      role: 'VEHICLE_MODEL',
      brandId: selectedVehicleBrand?.id,
    });
  }, [selectedVehicleBrand]);
  const dropdownVehicleBrandEl = useMemo(() => {
    return (
      <CustomDropdown2
        id="brandId_filter"
        name="brandId_filter"
        toggleElement={
          <button
            className={`btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between`}
            type="button"
          >
            {selectedVehicleBrand?.name ?? 'Chọn hãng xe'}
          </button>
        }
        selectedValue={selectedVehicleBrand}
        dropdownMenuItems={[{ name: 'Hãng xe', role: 'VEHICLE_BRAND' }]}
        getSubItems={async (item) => {
          return ChargeHelper.API.VehicleBrand.requestGetVehicleBrandList({
            page: item?.page || 0,
            limit: 10,
            q: item?.q || '',
          }).then((data) => {
            return {
              values: data.brands?.map((row) => ({
                id: row?.brandId,
                name: row?.name,
                item: row,
              })),
              total: data.total,
            };
          });
        }}
        dropdownMenuStyle={{ maxHeight: '30vh' }}
        dropdownMenuClassName="overflow-auto w-100"
        onChange={(value) => {
          setSelectedVehicleBrand(value);
          setSelectedVehicleModel(null);
          setFilterBrandId(value?.id);
        }}
        isDropdownForm={true}
        titleSearchable={true}
        searchable={true}
        searchFormClassName="mx-3 my-1 search-form-border"
        ignoreConfirmClick={true}
        defaultValue={{
          name: 'Hãng xe',
          role: 'VEHICLE_BRAND',
        }}
        footerEl={
          <div
            className="p-4 position-sticky sticky-bottom bg-white"
            style={{
              borderTop: `1px solid ${AppColors.gray[300]}`,
            }}
          >
            {UIHelper.buildNegativeButton('Bỏ chọn', () => {
              setSelectedVehicleBrand(null);
              setSelectedVehicleModel(null);
              setFilterBrandId('');
            })}
          </div>
        }
      />
    );
  }, [selectedVehicleBrand]);
  const dropdownVehicleModelEl = useMemo(() => {
    return (
      <CustomDropdown2
        id="modelId_filter"
        name="modelId_filter"
        toggleElement={
          <button
            className={`btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between ${
              !selectedVehicleBrand ? 'disabled' : ''
            }`}
            type="button"
          >
            {selectedVehicleModel?.name ?? 'Chọn dòng xe'}
          </button>
        }
        selectedValue={selectedVehicleModel}
        dropdownMenuItems={[{ name: 'Dòng xe', role: 'VEHICLE_MODEL' }]}
        getSubItems={async (item) => {
          if (Utils.isValid(selectedVehicleBrand?.id))
            return ChargeHelper.API.VehicleModel.requestGetVehicleModelList(
              selectedVehicleBrand?.id,
              {
                page: item?.page || 0,
                limit: 10,
                q: item?.q || '',
              }
            ).then((data) => {
              return {
                values: data.models?.map((row) => ({
                  id: row?.modelId,
                  name: row?.name,
                  item: row,
                })),
                total: data.total,
              };
            });
        }}
        dropdownMenuStyle={{ maxHeight: '30vh' }}
        dropdownMenuClassName="overflow-auto w-100"
        onChange={(value) => {
          setSelectedVehicleModel(value);
          setFilterModelId(value?.id);
        }}
        isDropdownForm={true}
        titleSearchable={true}
        searchable={true}
        searchFormClassName="mx-3 my-1 search-form-border"
        ignoreConfirmClick={true}
        disabled={!selectedVehicleBrand}
        defaultValue={defaultDropdownVehicleModel}
        footerEl={
          <div
            className="p-4 position-sticky sticky-bottom bg-white"
            style={{
              borderTop: `1px solid ${AppColors.gray[300]}`,
            }}
          >
            {UIHelper.buildNegativeButton('Bỏ chọn', () => {
              setSelectedVehicleModel(null);
              setFilterModelId('');
            })}
          </div>
        }
      />
    );
  }, [selectedVehicleBrand, selectedVehicleModel, defaultDropdownVehicleModel]);

  // MARK: ---- METHODS ----
  const handleApplyFilter = () => {
    ChargeHelper.Filter.chargeVehicleList = {
      page: 0,
      limit: AppConfigs.defaultPageLimit,
      q: filterQ,
      status: filterStatus,
      brandId: filterBrandId,
      modelId: filterModelId,
      autoCharge: filterAutoCharge,
    };
    if (onSelectedBrandChange) onSelectedBrandChange(selectedVehicleBrand);
    if (onSelectedModelChange) onSelectedModelChange(selectedVehicleModel);
    if (onApply) onApply();
    if (closeDropdown) closeDropdown();
  };
  const handleClearFilter = () => {
    ChargeHelper.Filter.chargeVehicleList = {
      page: 0,
      limit: AppConfigs.defaultPageLimit,
      q: '',
      status: '',
      brandId: '',
      modelId: '',
      autoCharge: '',
    };
    setSelectedVehicleBrand(null);
    setSelectedVehicleModel(null);
    if (onSelectedBrandChange) onSelectedBrandChange(null);
    if (onSelectedModelChange) onSelectedModelChange(null);
    if (onCancel) onCancel();
    if (closeDropdown) closeDropdown();
  };

  return (
    <div className="py-4">
      <div className="row m-0 px-2">
        {/* tim kiem */}
        <div className="col-12 mb-4 px-2">
          <KTFormSearch
            name="search_filter"
            placeholder="Theo biển số xe, số khung..."
            value={filterQ}
            onSubmit={(text) => {
              setFilterQ(text);
            }}
          />
        </div>
        {/* hang xe */}
        <div className="col-6 mb-4 px-2">
          {UIHelper.buildFormLabel('Hãng xe')}
          {dropdownVehicleBrandEl}
        </div>
        {/* dong xe */}
        <div className="col-6 mb-4 px-2">
          {UIHelper.buildFormLabel('Dòng xe')}
          {dropdownVehicleModelEl}
        </div>
        {/* che do sac */}
        <div className="col-6 mb-4 px-2">
          {UIHelper.buildFormLabel('Chế độ sạc')}
          <KTBSDropdown
            name="autoCharge_filter"
            toggleElement={
              <button
                className="btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between"
                type="button"
              >
                {filterAutoCharge === 'true'
                  ? 'Sạc nhận diện xe'
                  : filterAutoCharge === 'false'
                    ? 'Sạc thông thường'
                    : 'Tất cả'}
              </button>
            }
            selectedValue={filterAutoCharge ?? ''}
            dropdownMenuItems={[
              { name: 'Tất cả', value: '' },
              { name: 'Sạc thông thường', value: 'false' },
              { name: 'Sạc nhận diện xe', value: 'true' },
            ]}
            dropdownMenuClassName="overflow-auto w-100"
            dropdownMenuStyle={{ maxHeight: '30vh' }}
            onChange={(value) => {
              setFilterAutoCharge(value);
            }}
            isDropdownForm={true}
          />
        </div>
      </div>
      {/* actions */}
      <div
        className="px-4 pt-4 pb-0 d-flex align-items-center justify-content-end gap-3"
        style={{
          borderTop: `1px solid ${AppColors.gray[200]}`,
        }}
      >
        {UIHelper.buildNegativeButton('Xóa bộ lọc', handleClearFilter)}
        {UIHelper.buildGreenButton('Áp dụng', handleApplyFilter)}
      </div>
    </div>
  );
}

export default ChargeVehicleListFilterView;
